import React, { useEffect, Component, Fragment, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import { DateUtil } from "../../../datas/DateUtil";
import { FxmsData } from "../../../datas/FxData";
import { width } from "@mui/system";
import { FaceRetouchingOffSharp } from "@mui/icons-material";
import {DataSelecter} from "./DataSelecter";

HighchartsMore(Highcharts);

/**
 * 라인 챠트
 * 개발자 : 김영상
 * 개발년원 : 2023.2
 * @param {*} fxUiGrp
 * @param {*} fxUiGrpItem
 * @returns
 */
export const FxLineZoomChart = (props) => {

  const { id, fxUiGrp, fxUiGrpItem, editable } = props;
  const [title, setTitle] = useState('')
  const [titleSensor, setTitleSensor] = useState("");
  const [titlePsItem, setTitlePsItem] = useState("");
  //list
  const [sensorList, setSensorList] = useState(props.sensorList)
  const [psItemList, setPsItemList] = useState(props.psItemList)
  //selected
  const [psItem, setPsItem] = useState('');
  const [sensor, setSensor] = useState('');

  const [ranges, setRanges] = useState([]);
  const [averages, setAverages] = useState([]);
  const [intervalId, setIntervalId] = useState(null);

  const [dataStat, setDataStat] = useState({});
  const [datas, setDatas] = useState([]);

  //chart
  const [yAxis, setYAxis] = useState('')
  const [unit, setUnit] = useState('')

  useEffect(() => {
    if(props.item.fxUiDashbItemAttrs) {
      if(props.item.fxUiDashbItemAttrs.length > 0) {
        setTitle(props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'title') ? props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'title').attrVal:'')
        let tempSensor = props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'sensor') ? props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'sensor').attrVal : ''
        let tempPsItem = props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'psItem') ? props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'psItem').attrVal : ''
        if(tempSensor != ''){
          handleSensorChange({target:{value:parseInt(tempSensor)}})
        }
        if(tempPsItem != ''){
          handlePsItemChange({target:{value:tempPsItem}})
        }
        showDatas(parseInt(tempSensor),tempPsItem)
      }
    }
  }, []);
  const showDatas = (sensorId,psId) => {
    FxmsData.GET("fxmsPs/value", {
      moNo: sensorId,
      psId: psId,
      psKindName: "MIN5",
      psStatFuncList: "SUM,AVG",
      startPsDate: DateUtil.getDtm(new Date().getTime() - 86400000 * 1),
      endPsDate: DateUtil.getDtm(),
    }).then(res=>{
      let averages = [];
      let ranges = [];
      let result = res.data.datas
      if (result) {
        for (let i = 0; i < result[0].valueList.length; i++) {
          result[0].valueList[i][0] = DateUtil.makeDate(
              result[0].valueList[i][0]
          ).getTime();
        }
        setDatas(result[0].valueList);
        makeStat(result[0].valueList);
      } else {
        setTitleSensor(sensor.moName + " 데이터 조회 오류!!");
        setTitlePsItem(psItem.psName + " 데이터 조회 오류!!");
      }
    });
  }
  const makeStat = (datas) => {
    let minVal = Number.MAX_SAFE_INTEGER;
    let minTime = Number.MAX_SAFE_INTEGER;
    let maxVal = Number.MIN_SAFE_INTEGER;
    let maxTime = Number.MIN_SAFE_INTEGER;
    let avgVal = 0;

    for (let n of datas) {
      if (minVal > n[1]) minVal = n[1];
      if (minTime > n[0]) minTime = n[0];

      if (maxVal < n[1]) maxVal = n[1];
      if (maxTime < n[0]) maxTime = n[0];

      for (let i = 0; i < datas.length; i++) {
        avgVal += datas[i][1];
      }
      avgVal = avgVal / datas.length;
    }

    setDataStat({
      times: renderDateMstime(minTime) + " ~ " + renderDateMstime(maxTime),
      count: datas.length.toLocaleString(),
      minVal: minVal.toLocaleString(),
      maxVal: maxVal.toLocaleString(),
      avgVal: avgVal.toFixed(2),
    });
  };
  const getData = (id,name) => {
    if(name === "sensor"){
      showDatas(id,psItem)
    }else if(name === "psItem"){
      showDatas(sensor,id)
    }

  }
  const handleSensorChange = (e) => {
    setSensor(e.target.value)
    setTitleSensor(sensorList.find(x=>x.moNo===e.target.value) ? sensorList.find(x=>x.moNo===e.target.value).moDispName : '')
    if(psItem != ''){
      if(intervalId){
        clearInterval(intervalId)
      }
      const intId = setInterval(getData.bind(this,e.target.value,'sensor'),1000)
      setIntervalId(intId)
      getData(e.target.value,'sensor')
    }
  }
  const handlePsItemChange = (e) => {
    setPsItem(e.target.value)
    setTitlePsItem(psItemList.find(x=>x.psId===e.target.value) ? psItemList.find(x=>x.psId===e.target.value).psName : '')
    setUnit(psItemList.find(x=>x.psId===psItem) ? psItemList.find(x=>x.psId===psItem).psUnit:'')
    if(sensor != ''){
      if(intervalId){
        clearInterval(intervalId)
      }
      const intId = setInterval(getData.bind(this,e.target.value,'psItem'),1000)
      setIntervalId(intId)
      getData(e.target.value,'psItem')
    }
  }
  const handleTitleChange = (e) => {
    setTitle(e.target.value)
  }
  const saveCurrentData = () => {
    let currentData = []
    currentData.push({uiNo:props.item.uiNo,attrName:'title',attrVal:title,attrType:'string'})
    currentData.push({uiNo:props.item.uiNo,attrName:'psItem',attrVal:psItem,attrType:'string'})
    currentData.push({uiNo:props.item.uiNo,attrName:'sensor',attrVal:sensor,attrType:'string'})
    props.save(currentData,props.item.uiNo,props.item.opId)
  }
  const removeItem = () => {
    props.removeItem(props.item.uiNo)
  }
  return (
      <>
        {props.editable ? <DataSelecter mode={'zoom'} sensorList={sensorList} sensor={sensor} psItem={psItem} psItemList={psItemList} handleCloseAndSave={saveCurrentData} handleTitleChange={handleTitleChange} handleSensorChange={handleSensorChange} handlePsItemChange={handlePsItemChange} removeItem={removeItem}/>: '' }
        <HighchartsReact
        className="HighChart"
            // callback={this.setChart}
            containerProps={{ style: { width: "100%", height: "100%" } }}
            highcharts={Highcharts}
            options={{
              chart: {zoomType: "x",backgroundColor: "rgba(255,255,255, 0.1)"},
              title: {text: title, style: { color: "white" },},
              subtitle: {text: titleSensor+" :: "+titlePsItem, style: { color: "white" },},
              xAxis: {type: "datetime", accessibility: {rangeDescription: ""}},
              yAxis: {title: {text:  unit, style: { color: "white" }}},legend: {enabled: false,},
              tooltip: {crosshairs: true, shared: true, valueSuffix: " " +  unit},
              plotOptions: {area: {fillColor: {linearGradient: {x1: 255,y1: 255, x2: 255, y2: 255,},
                    stops: [[0, Highcharts.getOptions().colors[0]], [1, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0).get("rgba"),],],},
                  marker: {radius: 2,}, lineWidth: 2, color: 'yellow',
                  states: {hover: {lineWidth: 1,},}, threshold: null,},},
              series: [{
                type:"area",
                name:  titlePsItem,
                data: datas,
                zIndex: 1,
                marker: {
                  fillColor: "white",
                  lineWidth: 2,
                  lineColor: Highcharts.getOptions().colors[0],
                },
              },
              ],
            }}
        />
        <div style={{ display: "inline-block", padding: "7px 10px 0px 10px" }}>
          <div style={{ fontSize: 20 }}>
            조회기간 :{dataStat.times} / 총 건수 : {dataStat.count} / 최소값 :{" "}
            {dataStat.minVal} / 최대값 : {dataStat.maxVal} / 평균값 :{" "}
            {dataStat.avgVal}
          </div>
        </div>
      </>

  );
};

export default FxLineZoomChart;








export function renderDateMstime(mstime) {
  function addZero(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  const d = new Date();

  if (mstime != undefined) {
    d.setTime(mstime);
  }

  let year = d.getFullYear();
  let month = d.getMonth() + 1;
  let day = d.getDate();
  let hour = d.getHours();
  let minutes = d.getMinutes();
  let seconds = d.getSeconds();

  return (
    year +
    "-" +
    addZero(month) +
    "-" +
    addZero(day) +
    " " +
    addZero(hour) +
    ":" +
    addZero(minutes) +
    ":" +
    addZero(seconds)
  );
}
